import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { VisibilityPredicateType } from "../../registry/visibility";

/**
 * Throw Error Step
 *
 * Always throws an error with a configurable message.
 * Useful for testing workflow error handling and Sentry integration.
 */
export const throwErrorStep = defineStepConfig({
  type: "throw_error",
  name: "Throw Error",
  description: "Throws an error with a configurable message (for testing)",
  category: "Debug",
  visibility: [[{ type: VisibilityPredicateType.Admin }]],
  inputSchema: z.object({}),

  outputSchema: z.object({}),

  configSchema: z.object({
    message: z
      .string()
      .prefault("Intentional test error from throw_error step")
      .describe("The error message to throw"),
  }),

  emits: [] as const,
});
